export default __webpack_public_path__ + "static/media/eggstudio_2.9fb8ba9c.png";